const OV_RV_KEY = 'ov_recently_viewed';
const OV_RV_MAX = 8;

function ovRvGet() {
  try { return JSON.parse(localStorage.getItem(OV_RV_KEY) || '[]'); }
  catch { return []; }
}

function ovRvSave(items) {
  localStorage.setItem(OV_RV_KEY, JSON.stringify(items));
}

function ovRvTrack(product) {
  if (!product || !product.id) return;
  let items = ovRvGet().filter(p => p.id !== product.id);
  items.unshift(product);
  ovRvSave(items.slice(0, OV_RV_MAX));
}

function ovRvRender() {
  const sections = document.querySelectorAll('.ov-rv');
  if (!sections.length) return;

  const items = ovRvGet();

  sections.forEach(section => {
    const track = section.querySelector('.ov-rv__track');
    if (!track) return;

    if (!items.length) {
      section.classList.add('ov-rv--empty');
      return;
    }

    track.innerHTML = items.map(p => `
      <a href="${p.url}" class="ov-rv__card">
        <div class="ov-rv__img-wrap">
          <img src="${p.image}" alt="${p.title}" loading="lazy" class="ov-rv__img ov-rv__img--primary" width="400" height="400">
          ${p.image2 ? `<img src="${p.image2}" alt="" loading="lazy" class="ov-rv__img ov-rv__img--hover" width="400" height="400">` : ''}
        </div>
        <div class="ov-rv__card-body">
          ${p.type ? `<div class="ov-rv__tag">${p.type}</div>` : ''}
          <div class="ov-rv__name">${p.title}</div>
          <div class="ov-rv__price">${p.price}</div>
        </div>
      </a>
    `).join('');
  });
}

document.addEventListener('DOMContentLoaded', function () {
  if (window.ovCurrentProduct) {
    ovRvTrack(window.ovCurrentProduct);
  }
  ovRvRender();
});
